import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { formatRateRange } from '../../../../../seeker/details/New_UI/Components/util';
import { getJobExpiresDate } from '../../util';
import JobsSettingCard from '../../Component-UI/JobsSettingCard';
import RenewJobInAdvance from '../../Component-UI/RenewJobInAdvance';
import EmojiFlagText from '../../../../../custom-ui/emoji/EmojiFlagText';

// Main JobCard component
const JobCard = ({ jobData }: any) => {
  const {
    companyLogo,
    companyFullName,
    jobName,
    openings,
    workType,
    workTerm,
    workSettings,
    makeLiveDate,
    payRate,
    solutionType,
    applicationFlow,
    jobState,
    status, // assuming you have a status property to show the "DRAFT" label
  } = jobData || {};


  const getExpiresDays: any = getJobExpiresDate(jobData?.makeLiveDate);
  const isclosed = ["closed_filled", "closed_cancelled", "closed_job_expired"].includes(jobState) ? true : false

  let jobStateClr = jobState === "live" ? "bg-[#C6FAD0] text-[#2CE252]"
    : jobState === "closed_cancelled" || jobState === "closed_filled" || jobState === "closed_job_expired" ? "bg-[#FAC7C7] text-[#E02F2F]"
      : jobState === "on_hold" ? "bg-[#D6D6FB] text-[#5B5BD3]"
        : jobState === "draft" ? "bg-[#FDE1AF] text-[#EF9D0D]" : ""

  let jobStatus = jobState === "live" ? "LIVE"
    : jobState === "closed_cancelled" ? "CANCELLED"
      : jobState === "on_hold" ? " ON HOLD"
        : jobState === "draft" ? "DRAFT"
          : jobState === "closed_filled" ? "FILLED"
            : jobState === "closed_job_expired" ? "EXPIRED" : ""
  return (
    <div className={`w-full h-full ${jobStateClr} pt-[3px] h-[100%]  rounded-lg`}>
      <div className="w-full h-full  bg-white rounded-lg py-3 px-3  relative">
        <div >
          <div className='flex justify-between'>
            <h2 className="text-xl font-bold text-instant-teams-blue-Main">
              <EmojiFlagText>{jobName}</EmojiFlagText>
            </h2>
            <div className='flex mr-[-2px]  items-center' >
              <div className='h-8 w-6 bg-white rotate-45 mt-[5px] mr-[-8px]'>
              </div>
              <div className={`${jobStateClr}  mr-[-10px] px-8 py-1 items-center '`}>
                <h1 className='text-lg '>
                  {jobStatus}
                </h1>
              </div>
            </div>

          </div>
          <div className=' grid grid-cols-2 w-full justify-between mt-[-5px]'>
            <div>


              {payRate?.salary && (
                <p className="text-sm text-gray-700">
                  {formatRateRange("salary", payRate?.salary)}
                </p>
              )}
              {payRate?.hourly && <p className="text-sm text-gray-600">{formatRateRange("hoursPerWeek", payRate?.hourly)}</p>}
              {payRate?.type == "unpaid_internship" && <p className="text-sm text-gray-600">Unpaid Internship</p>}
            </div>
            <div className='mt-2 flex  flex-col items-end justify-end mr-[-5px]  space-x-1'>
              {makeLiveDate && !isclosed && solutionType!=="bpo" && (
                <>
                  <p
                    className={`text-[14px] ${getExpiresDays?.rawDaysLeft <= 2 && getExpiresDays?.rawDaysLeft >= 0
                      ? "text-[#FB4141]"
                      : "text-instant-teams-blue-Main"
                      } ml-2`}
                  >
                    {getExpiresDays?.rawDaysLeft === 0 ? (
                      <>
                        {/* <span className="font-[600]">Expires Today [ <span className='underline text-instant-teams-blue-Main font-thin'> Renew in Advance</span> ] </span> */}
                        <p className="text-[14px] text-red-500 font-semibold">
                          Expires Today
                          {/* &nbsp;<button className=" text-instant-teams-blue-Main underline hover:text-blue-700">
                            Renew now
                          </button>&nbsp; */}
                        </p>
                      </>
                    ) : getExpiresDays?.rawDaysLeft < 0 ? (
                      <span className="font-semibold">Expired</span>
                    ) : (
                      <>
                        Expires in: <span className="font-bold">{getExpiresDays?.text}</span>


                      </>
                    )}
                  </p>
                  {getExpiresDays?.rawDaysLeft <= 2  &&
                    <RenewJobInAdvance
                    status={jobData?.jobState}
                    collection="JobDetailsNewCollection"
                    recId={jobData?.id}
                    jobData={jobData}
                    required={false}
                    daysLeft={getExpiresDays?.rawDaysLeft}
                    name="jobState"
                    display="Status"
                    placeholder=""
                    directions=""
                  />}

                </>

              )}
            </div>

          </div>
          <hr className="mt-4 border-t border-gray-300" />
          {!jobData?.noATS && <div className='mt-2'>
            <p className="text-sm  text-gray-500">Apply Link</p>
            <a

              href={applicationFlow}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-500 hover:underline"
            >
              <p className='text-instant-teams-blue-Main  mt-1'>
                {applicationFlow}
              </p>

            </a>
          </div>}

        </div>
      </div>
    </div>
  );
};

export default JobCard;


